import { map } from "../../src/js/modules/Helpers";

/**
 * Handles the artwork hero behavior.
 */
let ArtworkHero = {
	/**
	 * Entry point
	 */
	_init: () => {
		// listen for document ready.
		document.addEventListener('DOMContentLoaded', ArtworkHero._ready);
	},
	/**
	 * When document ready
	 */
	_ready: () => {
		// found the artworkhero el on the single artwork page?
		if (document.querySelector('.single-artwork .artworkhero') instanceof HTMLElement) {
			// fire scrollHandler on _ready
			ArtworkHero._scrollHandler();
			// listen for window scroll
			window.addEventListener('scroll', ArtworkHero._scrollHandler);
		}

		const header = document.querySelector('header.wp-block-template-part');
		header.classList.add('opacity');
	},
	/**
	 * When window scrolling
	 */
	_scrollHandler: () => {
		// alias the tint el
		const tint = document.querySelector('.artworkhero-tint');

		// map window scrollY to tint opacity
		tint.style.opacity = map(window.scrollY, 0, window.innerHeight, 0, 1);

		// try to get the main header
		const header = document.querySelector('header.wp-block-template-part');
		const artworkHero = document.querySelector('.artworkhero');
		
		//  if header found
		if (header instanceof HTMLElement) {
			// give it an opaque class if its below the tint - nav height and get rid of that class if it's not
			if (window.scrollY > tint.offsetTop + tint.getBoundingClientRect().height - header.getBoundingClientRect().height) {
				header.classList.add('opaque');
				artworkHero.classList.add('out');
			}
			else {
				header.classList.remove('opaque');
				artworkHero.classList.remove('out');
			}
		}
	}
}

// away wee gooo
ArtworkHero._init();